import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TEXT_COLOR_DATA } from 'assets/color-data/textcolor-data';
import { Color } from 'fabric/fabric-impl';
import { Observable, fromEvent, BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-car-color-change',
  templateUrl: './car-color-change.component.html',
  styleUrls: ['./car-color-change.component.scss']
})
export class CarColorChangeComponent implements OnInit, AfterViewInit {
  @Input()
  public activeObject;
  @Output() fillClicked = new EventEmitter<void>();
 
  constructor() { }

  ngOnInit(): void {
    console.log(this.activeObject, 'xx-')
  }

  ngAfterViewInit(): void {
      
  }

  public fillClick(): void {
    this.fillClicked.emit();
  }

  public get fillColor(): string {
    return this.activeObject !== undefined
      ? this.activeObject
      : 'white';
  }

  public get fillColorName(): string {
    const match = TEXT_COLOR_DATA.filter(a => {
      return a.value === this.fillColor;
    });
    if (match.length > 0) {
      return match[0].name;
    }
    return '';
  }

  public getOpacityForColor(): number {
    if (this.activeObject) {
      return 1;
    }
    return 0.2;
  }
  
}
